<template lang="html">
  <booking-event-form
    v-bind="$attrs"
    @input="$emit('input', $event)"
  >

    <template v-slot:resources="{
      item,
      required,
      validNumber,
      validResources,
      validDateAndTime,
      resourcesLoading,
      resourceOptions,
      onInput
    }">
      <div class="d-flex">
        <v-text-field
          label="Guests"
          v-model="item.guests"
          @input="onInput"
          type="tel"
          autocomplete="off"
          :rules="[required, validNumber]"
        />
        <v-text-field
          label="Whereof children"
          v-model="item.guests_children"
          @input="onInput"
          type="tel"
          autocomplete="off"
          :rules="[required, validNumber, (v) => !v || Number(v) < Number(item.guests) || 'Must be less than number of guests']"
          class="ml-4"
        />
      </div>
      <v-select
        label="Tables"
        v-model="item.resources"
        @input="onInput"
        :items="resourceOptions"
        item-text="title"
        item-value="id"
        multiple
        chips
        deletable-chips
        :loading="resourcesLoading"
        :disabled="!validDateAndTime"
        :messages="validDateAndTime ? `${seatsTotal} seats` : 'Enter valid date and time to see available tables'"
        class="mb-2"
        :rules="[validResources]"
      >
        <template v-slot:item="{item: resource}">
          <v-list-item-action>
            <v-icon>{{resource.selected ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline'}}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{resource.title}}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{resource.disabled ? 'Busy, ' : ''}}{{resource.seats}} seats
            </v-list-item-subtitle>
          </v-list-item-content>
        </template>
      </v-select>
      <v-expand-transition>
        <div v-show="Number(item.guests || 0) > seatsTotal">
          <v-alert
            dense
            outlined
            icon="mdi-alert"
            type="warning"
          >
            More guests than seats ({{seatsTotal}}/{{item.guests}})
          </v-alert>
        </div>
      </v-expand-transition>
    </template>

  </booking-event-form>
</template>

<script>
import {BookingEventForm} from 'dync-booking';
import {getItemById} from '@dynapp/wc-api-generic';

export default {
  inheritAttrs: false,
  data() {
    return {};
  },
  computed: {
    seatsTotal() {
      return (this.$attrs.item.resources || []).reduce((acc, resourceId) => {
        var resource = getItemById(this.$attrs.resources, resourceId);
        if (resource) {
          return acc + resource.seats;
        }
        return acc;
      }, 0);
    }
  },
  components: {
    BookingEventForm
  }
}
</script>

<style lang="css" scoped>
</style>
